import { render, staticRenderFns } from "./SpiaggeTask.vue?vue&type=template&id=3ca7341e&scoped=true&"
import script from "./SpiaggeTask.vue?vue&type=script&lang=js&"
export * from "./SpiaggeTask.vue?vue&type=script&lang=js&"
import style0 from "./SpiaggeTask.vue?vue&type=style&index=0&id=3ca7341e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca7341e",
  null
  
)

export default component.exports